import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FilterBy } from 'globals/enums';

export const initialState = {
  filterBy: [FilterBy.Critical],
};

const alertFilterSlice = createSlice({
  name: 'alertFilter',
  initialState,
  reducers: {
    setFilterBy: (state, { payload }) => {
      const isCriticalOrAdded = payload === FilterBy.Critical || payload === FilterBy.Added;
      const hasFilter = state.filterBy.some((item) => item === payload);

      if (isCriticalOrAdded) {
        state.filterBy = hasFilter ? [FilterBy.Public] : [payload];
        return;
      }

      if (hasFilter) {
        const newFilterBy = state.filterBy.filter((item) => item !== payload);
        state.filterBy = newFilterBy.length ? newFilterBy : [FilterBy.Critical];
        return;
      }

      state.filterBy = [
        ...state.filterBy.filter((item) => item !== FilterBy.Critical && item !== FilterBy.Added),
        payload,
      ];
    },
    resetFilterBy: (state, actions: PayloadAction<null>) => {
      state.filterBy = initialState.filterBy;
    },
  },
});

export const { setFilterBy, resetFilterBy } = alertFilterSlice.actions;

export default alertFilterSlice.reducer;
